import React from 'react';
import OptionsGroup from '../../moleculesv2/OptionsGroup/OptionsGroup';

const OPCIONES_ESCALA = [
    { label: 'Día',       value: 'dia'       },
    { label: 'Semana',    value: 'semana'    },
    { label: 'Mes',       value: 'mes'       },
    { label: 'Trimestre', value: 'trimestre' },
];

// Props: escala (string activo), onChange (fn que recibe el nuevo valor)
const GanttToolbar = ({ escala, onChange }) => (
    <div className="GanttChart__toolbar">
        <OptionsGroup
        style={{ width: '350px' }}
            label="Escala"
            activeValue={escala}
            onSelect={onChange}
            options={OPCIONES_ESCALA}
        />
    </div>
);

export default GanttToolbar;
